import { connect } from 'react-redux'
import { initTagManager, loadFilterMeta } from 'Modules/searchFilters/actions'
import { updateLookupAreaFilter } from 'Modules/filters/actions'

import TagManager from './TagManager'

export default connect(state => ({
  metaLookup: state.searchFilters.filterLookup,
  isMetaFetching: state.searchFilters.isFetching,
  tagLookups: state.searchFilters.tagLookups,
  tagLookupsFetching: state.searchFilters.tagLookupsFetching,
  unitSystemIsImperial: state.app.unitSystemIsImperial,
  selectedFiltersList: state.filters.selectedFiltersList,
  addressIds: state.areaTags.addressId,
  lookups: state.lookups,
  lookupFetching: state.lookups.isFetchingReal,
}), {
  initTagManager,
  loadFilterMeta,
  updateLookupAreaFilter,
})(TagManager)

